window.InifECMobileApp.controller("ChangeEmailController", ['$scope', '$timeout', '$rootScope', '$stateParams', '$state', 'UserService',
    function($scope, $timeout, $rootScope, $stateParams ,$state , UserService) {

        var changeEmail = function() {
            UserService.changeEmail($scope.mrscid, $scope.token).then(function(result) {
                $state.go(window.STATES.HOME);
                $rootScope.$broadcast('OPEN_SUCCESS_MESSAGE_MODAL', {
                    title: "更新Email成功"
                });
                $rootScope.$broadcast("UPDATE_USER_INFO");
            },function(error) {
                $timeout(function() {
                    $state.go(window.STATES.HOME);
                    $rootScope.$broadcast('OPEN_ERROR_MESSAGE_MODAL', {
                        title: "無法認證您的 Email，請稍候再試"
                    });
                })
            })
        }

        var init = function() {
            changeEmail();
        };

        /*==========================
            Events
        ==========================*/

        /*==========================
            Members
        ==========================*/
        $scope.token = $stateParams.token;
        $scope.mrscid = $stateParams.mrscid;

        /*==========================
             Methods
        ==========================*/

        /*==========================
            init
        ==========================*/
        init();
    }
]);